import type { IsoPoint } from '@modo-vivo/contracts';
import { ENTRANCE_POINT, TABLE_SEATS } from './layout.js';

export function pathFromEntranceToTable(tableNumber: number): IsoPoint[] {
  const layout = TABLE_SEATS[tableNumber];
  if (!layout) {
    return [ENTRANCE_POINT];
  }
  return layout.approach;
}

export function pathFromTableToEntrance(tableNumber: number): IsoPoint[] {
  return [...pathFromEntranceToTable(tableNumber)].reverse();
}
